// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"295":"5207f0ca","660":"23a50806","818":"7a265f8c","872":"f021a515"}[chunkId] + ".js";
};